import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import {
    useGetControlProgramsControlProgramId,
    useGetControlProgramsControlProgramIdSuspense,
} from "api/generated/control-program/control-program";

export function useControlProgramQuery(controlProgramId: number) {
    return useGetControlProgramsControlProgramIdSuspense(controlProgramId, {
        query: {
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}

export function useOptionalControlProgramQuery(
    controlProgramId: number | null
) {
    return useGetControlProgramsControlProgramId(controlProgramId ?? 0, {
        query: {
            enabled: controlProgramId !== null,
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
